import { InputHTMLAttributes, FC } from 'react';

type UserSubmitProps = InputHTMLAttributes<HTMLInputElement>;

const UserSubmit: FC<UserSubmitProps> = ({ ...otherProps }) => {
    return (
        <div className='group'>
            <input className='loginInput' {...otherProps} />
            <div className='form-input-label'>connect code</div>
        </div>
    )
};

export default UserSubmit;